// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._nd5lah6b{grid-area:plot}._16jlkb7n{flex-grow:1}\n._18m9ewfl{overflow-y:visible}\n._1pbyidpf{z-index:0}\n._1reoewfl{overflow-x:visible}\n._1tkeidpf{min-height:0}\n._1ul9idpf{min-width:0}", ""]);
// Exports
module.exports = exports;
